export default "__VITE_ASSET__f2717bc0__"